module.exports = __webpack_public_path__ + "img/shipInfor.1b4c909e.png";